import Events from 'events';
import plugin from './plugin';

const pluginStatus = {};
const PLUGIN_STATUS_LOAD_FAILED = -1;
const PLUGIN_STATUS_FIRST_LOADING = 1;
const PLUGIN_STATUS_LOADED = 2;
const eventEmitter = new Events();

// 0 to turn off the limit
eventEmitter.setMaxListeners(0);

function getPluginByKey(data, context, resolve, reject) {
  const key = data.type;
  const body = data.body || {};
  if (pluginStatus[key] !== PLUGIN_STATUS_LOADED) {
    pluginStatus[key] = PLUGIN_STATUS_FIRST_LOADING;
  }
  plugin.getPlugins(key).then((plugins) => {
    pluginStatus[key] = PLUGIN_STATUS_LOADED;
    eventEmitter.emit('START_LOAD_NEXT_'.concat(key));
    let ret = body;
    for (let i = 0; i < plugins.length; i += 1) {
      try {
        // 约定所有插件内部执行的过程都是同步的
        // 前一个插件的执行结果作为后一个插件的入参
        // 约定最后一个插件为ui插件
        ret = plugins[i].fn.call(context, ret);
      } catch (e) {
        console.warn('插件执行异常', e);
      }
    }
    resolve(ret);
  }, (err) => {
    // @TODO 记录 log
    console.log(err);
    // 重试后续插件加载
    eventEmitter.emit('START_LOAD_NEXT_'.concat(key));
    pluginStatus[key] = PLUGIN_STATUS_LOAD_FAILED;
    reject(err);
  });
}

export default Object.create({
  /**
   * 注册插件
   */
  register(key, fn) {
    plugin.add(key, fn);
  },
  /**
   * 查找 data.key 对应的插件，用 data.body 执行插件
   * @param data
   * @param context
   * @returns {Promise}
   */
  push(data, context) {
    return new Promise((resolve, reject) => {
      if (!data || !data.type) {
        reject();
      }
      const key = data.type;
      if (pluginStatus[key] === PLUGIN_STATUS_FIRST_LOADING) {
        eventEmitter.once('START_LOAD_NEXT_'.concat(key), () => {
          getPluginByKey(data, context, resolve, reject);
        });
      } else {
        getPluginByKey(data, context, resolve, reject);
      }
    });
  },
});



// WEBPACK FOOTER //
// ./src/component/pipeline/index.js